// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1Metadata
 */
export interface V1Metadata {
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof V1Metadata
   */
  annotations?: { [key: string]: string };
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof V1Metadata
   */
  labels?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof V1Metadata
   */
  name?: string;
}

/**
 * Check if a given object implements the V1Metadata interface.
 */
export function instanceOfV1Metadata(value: object): value is V1Metadata {
  return true;
}

export function V1MetadataFromJSON(json: any): V1Metadata {
  return V1MetadataFromJSONTyped(json, false);
}

export function V1MetadataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1Metadata {
  if (json == null) {
    return json;
  }
  return {
    annotations: json['annotations'] == null ? undefined : json['annotations'],
    labels: json['labels'] == null ? undefined : json['labels'],
    name: json['name'] == null ? undefined : json['name'],
  };
}

export function V1MetadataToJSON(json: any): V1Metadata {
  return V1MetadataToJSONTyped(json, false);
}

export function V1MetadataToJSONTyped(
  value?: V1Metadata | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    annotations: value['annotations'],
    labels: value['labels'],
    name: value['name'],
  };
}
